export default function Placeholder({ title, note }) {
  return (
    <>
      <div className="page-header"><h1>{title}</h1></div>
      <div className="card empty">{note || 'Coming in a later phase.'}</div>
    </>
  );
}
